<template>
    <header
        class="admin-shell-header tw:relative tw:z-30 tw:flex tw:h-16 tw:shrink-0 tw:items-center tw:justify-between tw:gap-3 tw:bg-white tw:px-4 tw:md:px-6"
        :style="clubVars"
        :data-club-color="clubColor"
        data-testid="admin-header"
    >
        <div class="tw:flex tw:min-w-0 tw:items-center tw:gap-3.5">
            <button
                type="button"
                class="tw:-ml-2 tw:rounded-lg tw:p-2 tw:text-slate-500 tw:transition tw:hover:bg-slate-100 tw:hover:text-slate-900 tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-[color:var(--admin-club-color)]"
                :aria-expanded="sidebarExpanded ? 'true' : 'false'"
                aria-label="Toggle sidebar"
                data-testid="sidebar-toggle"
                @click="toggle"
            >
                <i class="fas" :class="collapsed ? 'fa-indent' : 'fa-outdent'" aria-hidden="true"></i>
            </button>

            <div class="tw:h-5 tw:w-px tw:shrink-0 tw:bg-slate-200"></div>

            <AdminBreadcrumb :items="breadcrumbItems" />
        </div>

        <div class="tw:flex tw:items-center tw:gap-2.5">
            <AdminTeatroSelector />
            <AdminCartWidget v-if="teatro && teatro.carrito_varios_eventos" />
            <AdminNotifications />
        </div>

        <span
            class="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:h-px tw:bg-slate-200"
            aria-hidden="true"
            data-testid="header-club-accent"
        ></span>
    </header>
</template>

<script setup>
    import { computed } from 'vue';
    import store from '@/store';
    import { useAdminSidebar } from '@/composables/admin/layout/useAdminSidebar';
    import { useAdminNavigation } from '@/composables/admin/layout/useAdminNavigation';
    import { useAdminClubIdentity } from '@/composables/admin/layout/useAdminClubIdentity';
    import AdminBreadcrumb from './AdminBreadcrumb.vue';
    import AdminCartWidget from './AdminCartWidget.vue';
    import AdminNotifications from './AdminNotifications.vue';
    import AdminTeatroSelector from './AdminTeatroSelector.vue';

    const { toggle, collapsed, isMobile, mobileOpen } = useAdminSidebar();
    const { breadcrumbItems } = useAdminNavigation();
    const { clubColor, clubTextColor } = useAdminClubIdentity();

    const sidebarExpanded = computed(() => (isMobile.value ? mobileOpen.value : !collapsed.value));

    const teatro = computed(() => store.getters.getTeatro);

    const clubVars = computed(() => ({
        '--admin-club-color': clubColor.value,
        '--admin-club-fg': clubTextColor.value
    }));
</script>
